import { Plugin } from "@ckeditor/ckeditor5-core";

export default class MinHeightPlugin extends Plugin {
  init() {
    const editor = this.editor;

    const minHeight = editor.config.get("minHeight") ?? "500px";

    const styleElement = document.createElement("style");
    styleElement.innerHTML = `.ck-content { min-height: ${minHeight} !important; }`;
    document.head.appendChild(styleElement);
  }
}
